export default {

	defaultWait : 300,

	go: function(event, direction, parentEl, selectorString) {
		// Sensible defaults for up/down functionality
		parentEl       = parentEl || document.body;
		selectorString = selectorString || 'a, input, button:not(.close), .fake-input';

		// Get all focusable elements within this component, use slice()
		// .. to convert the result into an array @todo: Use Array.from
		// .. instead of slice when babel introduced
		var focusable      = parentEl.querySelectorAll(selectorString),
			focusableArray = Array.prototype.slice.call(focusable),
			position       = focusableArray.indexOf(event.target),
			newPosition    = position + (direction === 'down' ? 1 : -1);

		// If a suitable element was found, focus() it
		focusableArray[newPosition] && focusableArray[newPosition].focus();
	},

	debounce : function(func, wait, immediate) {
		var timeout;
		wait = wait || this.defaultWait;
		return function() {
			var context = this, args = arguments;
			var later = function() {
				timeout = null;
				if (!immediate) func.apply(context, args);
			};
			var callNow = immediate && !timeout;
			clearTimeout(timeout);

			timeout = setTimeout(later, wait);
			if (callNow) func.apply(context, args);
		};
	},

	/**
	 * Focus on the next element (based on tab index) after the provided element's
	 * selector string.
	 *
	 * @param curSelectorString A selector to retrieve the currently focused element
	 */
	nextInput : function(curSelectorString) {
		var currentTabIndex = document.querySelector(curSelectorString).tabIndex;
		var nextInput = document.querySelector('[tabindex="' + (currentTabIndex + 1) + '"]');
		if (nextInput) {
			nextInput.focus();
		}
	}
}
